import { App } from '@capacitor/app';

/**
 * Set badge count (iOS only)
 * Android doesn't support badge counts like iOS
 * Badge is capped at 1 to prevent it from exceeding 1
 */
export async function setBadgeCount(count) {
  try {
    // Cap badge count at 1
    const cappedCount = Math.min(count, 1);
    await App.setBadgeCount({ count: cappedCount });
  } catch (error) {
    console.warn('[Badge] Failed to set badge count:', error);
  }
}
